import httpClient from '../../httpClient';
import { DataRoom } from 'router/subrouters/DataRoom/models/DataRoom';

/**
 * Same route as `dataRoomApi.room.getRoom`, on the platform client. Used outside the
 * Data Room to read the room's access confirmation settings and the current user's
 * side, which the file access drawer needs.
 */

function getRoom(dataRoomId: string) {
  return httpClient.get<DataRoom>(`data-rooms/${dataRoomId}`);
}

export default {
  getRoom,
};
